import * as React from "react";
import PropTypes from "prop-types";
import { Image, tokens, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  message: {
    fontSize: tokens.fontSizeHero900,
    fontWeight: tokens.fontWeightRegular,
    fontColor: tokens.colorNeutralBackgroundStatic,
  },
  
  imagecenter: {
    margin: "auto",
    display: "block",
  },
  welcome__header: {
    // display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingBottom: "15px",
    paddingTop: "30px",
    backgroundColor: tokens.colorNeutralBackground3,
  },
});

const Header = (props) => {
  const { title, logo, message } = props;
  const styles = useStyles();

  return (
    <section className={styles.welcome__header}>
    <Image width= "200px" height="auto" src={logo} alt={title}  className={styles.imagecenter}/>
          <h1 className={styles.message}>{message}</h1>
    </section>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  logo: PropTypes.string,
  message: PropTypes.string,
};

export default Header;
